import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { CellIndex } from 'types';

import './SpeedSlider.css';

export const RawSpeedSlider = ({ cellIndex, speed, handleChangeSpeed, t, styles }: OwnProps & RecomposeProps & TranslateProps & OemProps) =>
    <input
        id={ `speed-slider-${cellIndex}` }
        className="speed-slider"
        type="range"
        min="1"
        max="5"
        value={ speed }
        onChange={ handleChangeSpeed }
        title={ t('TOOLTIP_BUTTON_PTZ_SPEED') }
    />
;

type OwnProps = {
    cellIndex: CellIndex;
    speed: number;
    onChangeSpeed: (speed: number) => void;
};

type RecomposeProps = {
    handleChangeSpeed: React.ChangeEventHandler<HTMLInputElement>;
};

export const SpeedSlider = compose<OwnProps & RecomposeProps & TranslateProps & OemProps, OwnProps>(
    skin,
    translate(),
    withHandlers<OwnProps & RecomposeProps, RecomposeProps>({
        handleChangeSpeed: ({ onChangeSpeed }) => (e: React.ChangeEvent<HTMLInputElement>) => {
            const speed = parseInt(e.target.value, 10);
            onChangeSpeed(speed);
        },
    }),
)(RawSpeedSlider);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/controls/SpeedSlider.tsx